<template>
  <div class="confirm">
    <div class="title">{{ title || $t('que-ren') }}</div>
    <a-checkbox v-if="description" v-model:checked="checked">
      {{ description }}
    </a-checkbox>
    <div class="footer">
      <a-space>
        <a-button @click="$emit('cancel')">{{ $t('qu-xiao') }}</a-button>
        <a-button type="primary" :disabled="!checked" @click="$emit('ok')">
          {{ $t('que-ren') }}
        </a-button>
      </a-space>
    </div>
  </div>
</template>
<script lang="ts" setup>
const { $t } = useNuxtApp()
withDefaults(
  defineProps<{
    title?: string
    description?: string
  }>(),
  {
    // title: $t('que-ren'),
    description: '',
  }
)
defineEmits(['cancel', 'ok'])
const checked = ref(false)
</script>
<style lang="scss" scoped>
.confirm {
  .title {
    @apply text-center overflow-hidden text-[16px] font-semibold;
    color: var(--text-1);
    line-height: 1.5;
    margin-block-end: 20px;
  }
  .footer {
    margin-block-start: 20px;
    text-align: end;
  }
}
</style>
